import React, { useState } from "react";
import PropTypes from "prop-types";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import CustomSearchableSelect from "../../../../components/CustomForm/CustomSearchableSelect";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import {
  FormWrapper,
  Form,
  FormGroup
} from "../../../../components/CustomForm/FormStyles";
import Colors from "../../../../themes/Colors";

const ProcedimientosStandVirtualBusquedaForm = ({
  onSearch,
  tiposCobertura
}) => {
  const [tipoCoberturaSeleccionado, setTipoCoberturaSeleccionado] =
    useState("");

  return (
    <Section>
      <FormWrapper borderColor={Colors.transparent}>
        <Form justifyContent={"space-between"}>
          <FormGroup width={"48%"}>
            <CustomSearchableSelect
              label={"Tipo de Procedimiento"}
              placeholder={"Buscar por código o descripción..."}
              isLabelWithContainer={true}
              labelWidth={"100%"}
              width={"100%"}
              value={tipoCoberturaSeleccionado}
              onChange={setTipoCoberturaSeleccionado}
              options={
                tiposCobertura?.map((item) => ({
                  value: item.codigo,
                  label: `${item.descripcion} (${item.codigo})`
                })) || []
              }
            />
          </FormGroup>

          <FormGroup>
            <CustomButton
              label={"Buscar"}
              width={"200px"}
              onClick={() => onSearch(tipoCoberturaSeleccionado)}
            />
          </FormGroup>
        </Form>
      </FormWrapper>
    </Section>
  );
};

ProcedimientosStandVirtualBusquedaForm.propTypes = {
  onSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  tiposCobertura: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      descripcion: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ProcedimientosStandVirtualBusquedaForm;
